import React from 'react';
import { GraduationCapIcon } from 'lucide-react';
import { universities } from '../data/universityData';
interface FooterProps {
  onNavigate?: (page: string) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  const currentYear = new Date().getFullYear();
  const nav = (page: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (onNavigate) onNavigate(page);
  };
  return <footer className="bg-gray-50 border-t border-gray-200 py-12 mt-auto" data-id="element-149">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8" data-id="element-151">
          {/* Logo + Description */}
          <div className="col-span-1 md:col-span-2" data-id="element-152">
            <button onClick={nav('compare')} className="flex items-center gap-2 hover:opacity-80 transition-opacity mb-4" data-id="element-153">
              <div className="bg-[#e8594f] text-white p-1.5 rounded-lg" data-id="element-154">
                <GraduationCapIcon className="w-5 h-5" data-id="element-155" />
              </div>
              <span className="text-lg font-bold text-gray-900 tracking-tight" data-id="element-156">
                FindOnlineDegrees
              </span>
            </button>
            <p className="text-sm text-gray-500 leading-relaxed max-w-md" data-id="element-157">
              We help students find the right educational path by comparing top
              accredited online degree programs. Our mission is to make higher
              education more accessible and transparent.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-158">
            <h4 className="font-bold text-gray-900 mb-4" data-id="element-159">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-160">
              <li data-id="element-161">
                <button onClick={nav('colleges')} className="hover:text-[#3b82f6] text-left" data-id="element-162">
                  Colleges
                </button>
              </li>
              <li data-id="element-163">
                <button onClick={nav('partner-colleges')} className="hover:text-[#3b82f6] text-left" data-id="element-164">
                  Partner Colleges
                </button>
              </li>
              <li className="relative group" data-id="element-165">
                <span className="hover:text-[#3b82f6] cursor-pointer inline-flex items-center gap-1" data-id="element-166">
                  Universities
                </span>
                <div className="hidden group-hover:block absolute left-0 bottom-full mb-1 bg-white border border-gray-200 rounded-lg shadow-lg py-2 px-3 z-50 min-w-[220px]" data-id="element-167">
                  {Object.values(universities).map(uni => <button key={uni.slug} onClick={nav(`university/${uni.slug}`)} className="block w-full text-left text-sm text-gray-700 hover:text-[#3b82f6] py-1.5 transition-colors" data-id="element-168">
                      {uni.name}
                    </button>)}
                </div>
              </li>
              <li data-id="element-169">
                <button onClick={nav('compare')} className="hover:text-[#3b82f6] text-left" data-id="element-170">
                  Compare Schools
                </button>
              </li>
              <li data-id="element-171">
                <button onClick={nav('request-information')} className="hover:text-[#3b82f6] text-left" data-id="element-172">
                  Match to Colleges
                </button>
              </li>
              <li data-id="element-173">
                <button onClick={nav('articles')} className="hover:text-[#3b82f6] text-left" data-id="element-174">
                  Articles
                </button>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-175">
            <h4 className="font-bold text-gray-900 mb-4" data-id="element-176">Resources</h4>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-177">
              <li data-id="element-178">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-179">
                  Financial Aid Guide
                </a>
              </li>
              <li data-id="element-180">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-181">
                  Career Outlooks
                </a>
              </li>
              <li data-id="element-182">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-183">
                  Student Reviews
                </a>
              </li>
            </ul>
          </div>

          {/* About Us */}
          <div data-id="element-184">
            <h4 className="font-bold text-gray-900 mb-4" data-id="element-185">About Us</h4>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-186">
              <li data-id="element-187">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-188">
                  Contact Us
                </a>
              </li>
              <li data-id="element-189">
                <button onClick={nav('privacy-policy')} className="hover:text-[#3b82f6] text-left" data-id="element-190">
                  Privacy Policy
                </button>
              </li>
              <li data-id="element-191">
                <button onClick={nav('terms')} className="hover:text-[#3b82f6] text-left" data-id="element-192">
                  Terms & Conditions
                </button>
              </li>
              <li data-id="element-193">
                <button onClick={nav('cookie-policy')} className="hover:text-[#3b82f6] text-left" data-id="element-194">
                  Cookie Policy
                </button>
              </li>
              <li data-id="element-195">
                <button onClick={nav('ca-notice')} className="hover:text-[#3b82f6] text-left" data-id="element-196">
                  CA Notice at Collection
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8" data-id="element-197">
          <p className="text-xs text-gray-400 text-center mb-4" data-id="element-198">
            Advertising Disclosure: This website is an independent,
            advertising-supported comparison service. The offers that appear on
            this site are from companies from which we receive compensation.
            This compensation may impact how and where products appear on this
            site (including, for example, the order in which they appear). We do
            not include all available products or offers.
          </p>
          <p className="text-sm text-gray-500 text-center" data-id="element-199">
            &copy; {currentYear} FindOnlineDegrees. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}